import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  disabled: boolean
  label?: string
  onSave?: () => Promise<void>
}

export const SaveButton = ({ disabled, label, onSave }: Props) => {
  const [loading, setLoading] = useState(false)

  const handleOnClick = async () => {
    setLoading(true)

    await onSave?.()

    setLoading(false)
  }

  return (
    <Button
      type="primary"
      onClick={handleOnClick}
      disabled={disabled || loading}
      {...(loading && { iconName: 'add' })}
    >
      {label || i18n.t('common.save_changes')}
    </Button>
  )
}
